import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { jarvisPrimeRmsConstants } from "./jarvisPrimeRmsConstants";

const initialState = {
  executeSellCall: false,
  executeSellMsg: "",
  executeBuyCall: false,
  executeBuyMsg: "",
  rmsCalls: false,
  rmsMsg: "",
  sell: [],
  buy: [],
  isLoading: 0,
  hasRmsData: false,
  isPrimeOnboardingCompleted: true,
  isBuyCallEnabled: "",
};

export const jarvisPrimeRmsReducers = persistReducer(
  {
    storage,
    key: "rms",
    blacklist: ["isLoading"],
  },
  (state = initialState, { type, payload }) => {
    switch (type) {
      case jarvisPrimeRmsConstants.PRIME_RMS_REQUEST:
        return {
          ...initialState,
          isLoading: 1,
        };

      case jarvisPrimeRmsConstants.PRIME_RMS_RESPONSE:
        return {
          ...state,
          executeSellCall: payload.executeSellCall,
          executeSellMsg: payload.executeSellMsg,
          executeBuyCall: payload.executeBuyCall,
          executeBuyMsg: payload.executeBuyMsg,
          rmsCalls: payload.rmsCalls,
          rmsMsg: payload.rmsMsg,
          sell: payload.sell,
          buy: payload.buy,
          isLoading: 0,
          hasRmsData: true,
          isBuyCallEnabled: payload.isBuyCallEnabled,
        };

      case jarvisPrimeRmsConstants.PRIME_RESET_RMS_DATA:
        return initialState;

      default:
        return state;
    }
  }
);
